import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component } from '@angular/core';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, NgSelectModule],
  selector: 'svg-home-icon-svg',
  template: `<div class="svg-container"><svg height="27px" width="27px" viewBox="0 0 27 27" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <!-- Generator: Sketch 51.2 (57519) - http://www.bohemiancoding.com/sketch -->
  <desc>Created with Sketch.</desc>
  <defs></defs>
  <g id="Policy-found" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" font-family="Ionicons" font-size="36" font-weight="400">
      <g id="OB-06:-Policy-found-(B)-Copy" transform="translate(-66.000000, -400.000000)" fill="#737373">
          <text id="ion-ios-home---Ionicons">
              <tspan x="66" y="427"></tspan>
          </text>
      </g>
  </g>
</svg></div>
`,
})
export class HomeIconSvgComponent {}
